import React from 'react';
import Icon from '../../../components/AppIcon';

const SolutionSection = () => {
  const solutions = [
    {
      id: 1,
      icon: 'Zap',
      title: 'Unified Platform',
      description: 'All your business planning tools in one place - Business Model Canvas, Financial Analysis, and Goal Intelligence working together seamlessly.'
    },
    {
      id: 2,
      icon: 'Brain',
      title: 'AI-Powered Insights',
      description: 'Advanced machine learning algorithms analyze your data to provide predictive insights, risk assessments, and actionable recommendations.'
    },
    {
      id: 3,
      icon: 'LineChart',
      title: 'Predictive Analytics',
      description: 'Forecast revenue, identify trends, and simulate scenarios with our powerful predictive engine to make informed decisions.'
    },
    {
      id: 4,
      icon: 'CheckCircle',
      title: 'Goal Feasibility Analysis',
      description: 'Set realistic goals with AI-driven feasibility scoring, milestone tracking, and resource allocation recommendations.'
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 px-4 md:px-6 lg:px-8 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-12 lg:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-success/10 border border-success/20 rounded-full mb-4">
            <Icon name="Sparkles" size={16} color="var(--color-success)" />
            <span className="text-xs md:text-sm font-medium text-success font-caption">
              Our Solution
            </span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground mb-4">
            How Business Jadhak Solves It
          </h2>
          <p className="text-base md:text-lg text-muted-foreground font-body max-w-3xl mx-auto">
            We combine proven business frameworks with cutting-edge AI to deliver a comprehensive decision intelligence platform designed specifically for SMEs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {solutions?.map((solution, index) => (
            <div
              key={solution?.id}
              className="bg-card border border-border rounded-lg p-6 transition-smooth hover:elevation-md hover:border-primary/50 group"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-lg bg-primary/10 flex items-center justify-center mb-4 transition-smooth group-hover:bg-primary/20 group-hover:scale-110">
                <Icon
                  name={solution?.icon}
                  size={24}
                  color="var(--color-primary)"
                />
              </div>
              <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-3">
                {solution?.title}
              </h3>
              <p className="text-sm md:text-base text-muted-foreground font-body leading-relaxed">
                {solution?.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 md:mt-16 bg-gradient-to-r from-primary/10 via-secondary/10 to-accent/10 border border-primary/20 rounded-xl p-6 md:p-8 lg:p-10">
          <div className="flex flex-col lg:flex-row items-center gap-6 md:gap-8">
            <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0">
              <Icon name="Lightbulb" size={32} color="var(--color-primary)" />
            </div>
            <div className="flex-1 text-center lg:text-left">
              <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground mb-2">
                Root Your Strategy. Predict Your Growth.
              </h3>
              <p className="text-sm md:text-base text-muted-foreground font-body">
                Business Jadhak empowers SMEs to build solid foundations while forecasting future success with AI-driven intelligence.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;